import sc from 'styled-components';
import {UnifonTheme} from '@phonectas/unifon-ui-kit';


// products

export const ProductsContainer = sc.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  width: 100%;
  padding: 16px;
`;

export const ProductCard = sc.div<{selected: boolean}>`
  position: relative;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #2196f3;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  ${props => props.selected && `
    border-color: #2196f3;
    background-color: rgba(33, 150, 243, 0.05);
  `}
`;

export const SubscriptionCard = sc.div`
    background-color: rgba(222,233,251,0.5);
    border-radius: 8px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    height: 206px;
    width: 312px;
`;

export const PriceContainer = sc.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: baseline;
	gap: 8px;
`;

export const Price = sc.span<{theme: UnifonTheme}>`
	font-size: 24px;
	font-weight: bold;
	color: ${({theme}) => theme['palette'].primary};
`;

export const PriceUnit = sc.span<{theme: UnifonTheme}>`
	font-size: 14px;
	color: ${({theme}) => theme['palette'].primary};
`;

export const FeatureList = sc.ul`
	list-style-type: none;
	padding: 0;
	margin: 0;
`;

export const FeatureItem = sc.li`
	padding: 0;
	color: #333;
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const InfoBox = sc.div`
	background-color: #f0f8ff;
	padding: 12px;
	border-radius: 6px;
	margin-bottom: 16px;
	border-left: 4px solid #002664;
`;

export const ActionsContainer = sc.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 24px;
`;